
import './gsk-sso.css'

import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { GSKMain, IGskMainProps } from '../gsk-main-component/gsk-main'
import { store } from '@gsk-tech/gsk-react-framework'
 
export const GSKSSO: React.FC<IGskMainProps> = props => {
    console.log('SSO Loaded');
    console.log(store.getState());
    const loggedInUser = useSelector((state: any) => state.loggedInUser);
    const dispatch = useDispatch();

    useEffect(() => {
        if (!loggedInUser.isSignedIn && props.singleSignOn?.action) {
            dispatch(props.singleSignOn?.action);
        }
    }, [dispatch, loggedInUser.isSignedIn, props.singleSignOn?.action]); //executes again if any of dependencies changes

    if (loggedInUser.isSignedIn) {
        const appGroup = props.singleSignOn?.securityGroup;
        const userGroups: string[] = loggedInUser?.groups;
        const isAllowedAccess = appGroup && appGroup.length > -1 ? appGroup.some((r: string) => userGroups.includes(r)) : true;

        console.log('is found:', isAllowedAccess);

        if (isAllowedAccess) {
            return ( 
                    <GSKMain {...{ ui: props.ui }} />
            );
        } else {
            return (
                <div>
                    Sorry you are not part of the application security group, please contact the administrator.
                </div>
            );
        }
    } else if (loggedInUser.mudid !== '' && !loggedInUser.isSignedIn) {
        return (
            <div>
                Logged Out
            </div>
        );
    } else {
        return (
            <div className="loadingScreen">
                <img src="logo192.png" alt="GSK Logo" />
                <br/>
                <br/>
                <span>Loading...</span>
            </div>
        );
    }
};